import { ForYou } from "@/pages/FrontPage/ForYou/ForYou";
import { FavoriteSource } from "@/redux/frontPage/frontPageSlice";
import {
  userFavoriteClubIdsSelector,
  userFavoriteCountryIdSelector,
} from "@/redux/user/userSlice";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { Navigate, useNavigate } from "react-router";

/**
 * The front page's For You, in My Club's content area: the side panel's
 * Favorite club and Favorite country open it narrowed to that favourite.
 * Newest first, but the user can sort. Without the favourite it is about,
 * back to the club home (the panel opens the picker instead).
 */
export const MyClubFavorites = ({ type }: { type: "club" | "country" }) => {
  const clubIds = useSelector(userFavoriteClubIdsSelector);
  const countryId = useSelector(userFavoriteCountryIdSelector);
  const id = type === "club" ? clubIds[0] : countryId;
  const navigate = useNavigate();

  const source = useMemo<FavoriteSource | undefined>(
    () => (id != null ? { type, id } : undefined),
    [type, id],
  );

  // Picking the other kind of favourite moves to its page, so the side
  // panel and the header follow.
  const onSourceChange = (next: FavoriteSource) => {
    if (next !== "all" && next.type !== type)
      navigate(`/my-club/favorite-${next.type}`);
  };

  if (!source) return <Navigate to="/my-club" replace />;
  return (
    <ForYou
      initialSource={source}
      sortable
      hideHeading
      onSourceChange={onSourceChange}
    />
  );
};
